// extracted by mini-css-extract-plugin
export default {"inputGroup":"CompanyServiceForm_inputGroup__gR+wE","inputDate":"CompanyServiceForm_inputDate__nPhrr"};